import * as XLSX from 'xlsx';

export function ExportGraph(neovis: any) {
  const nodes: any[] = neovis.nodes.get();
  const edges: any[] = neovis.edges.get();

  // Mapa rápido id -> nodo
  const nodeMap = new Map<any, any>();
  nodes.forEach(n => nodeMap.set(n.id, n));

  // Mapa cuenta -> cliente a partir de aristas HAS_ACCOUNT
  const accountToCustomer = new Map<any, any>();
  edges.forEach(e => {
    if (e.raw?.type === 'HAS_ACCOUNT') {
      accountToCustomer.set(e.to, nodeMap.get(e.from));
    }
  });

  // ── Hoja "Personas" ─────────────────────────────────────────────
  const personasRows = nodes
    .filter(n => n.raw?.labels?.[0] === 'Customer')
    .map(n => {
      const cuentas = edges
        .filter(e => e.raw?.type === 'HAS_ACCOUNT' && e.from === n.id)
        .map(e => nodeMap.get(e.to)?.label ?? e.to)
        .join(', ');

      return {
        'ID Nodo': n.id,
        'Nombre': n.label ?? '',
        'Cédula / CI': n.raw?.properties?.id ?? n.value ?? '',
        'Cuentas Relacionadas': cuentas,
      };
    });

  // ── Hoja "Transferencias" ────────────────────────────────────────
  const transferRows = edges
    .filter(e => e.raw?.type === 'HAS_TRANSFERED')
    .map(e => {
      const fromNode = nodeMap.get(e.from);
      const toNode = nodeMap.get(e.to);
      const fromCustomer = accountToCustomer.get(e.from);
      const toCustomer = accountToCustomer.get(e.to);

      return {
        'ID Relación': e.id,
        'Cuenta Origen': fromNode?.label ?? e.from,
        'Persona Origen': fromCustomer?.label ?? '',
        'CI Origen': fromCustomer?.raw?.properties?.id ?? fromCustomer?.value ?? '',
        'Cuenta Destino': toNode?.label ?? e.to,
        'Persona Destino': toCustomer?.label ?? '',
        'CI Destino': toCustomer?.raw?.properties?.id ?? toCustomer?.value ?? '',
        'Monto': e.raw?.properties?.transfer_amount ?? e.value ?? '',
      };
    });

  // ── Crear libro Excel ────────────────────────────────────────────
  const wb = XLSX.utils.book_new();

  const wsPersonas = XLSX.utils.json_to_sheet(
    personasRows.length ? personasRows : [{ 'Sin datos': '' }]
  );
  XLSX.utils.book_append_sheet(wb, wsPersonas, 'Personas');

  const wsTransferencias = XLSX.utils.json_to_sheet(
    transferRows.length ? transferRows : [{ 'Sin datos': '' }]
  );
  XLSX.utils.book_append_sheet(wb, wsTransferencias, 'Transferencias');

  XLSX.writeFile(wb, 'grafo_export.xlsx');
}
